export default "__VITE_ASSET__DSJWskgq__"